import React from 'react';
import { Text } from 'components/Typography';
import * as S from './styles';

export interface OptionalAdornmentProps {}

const OptionalAdornment: React.FC<OptionalAdornmentProps> = () => (
  <S.Root>
    <Text variant="adornment">optional</Text>
  </S.Root>
);

export default OptionalAdornment;
